import { memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateDepositModalOption } from 'store/deposit/actions'
import { useDepositModalOption } from 'store/deposit/hook'
import { DepositModalOption } from 'store/deposit/types'
import { DepositSelectOption } from 'views/Deposit/DepositSelectOption'
import ModalLink from '../../components/ModalLink'
import { useModal } from '../../store/app/hooks'
import { DepositQrcode } from './DepositQrcode'
import { updateModal } from '../../store/app/actions/modalActions'

import { DepositContent } from './DepositContent'

export const Deposit = memo(() => {
  const dispatch = useDispatch()
  const [titleName, setTitleName] = useState<string>('Deposit')
  const modalOption = useDepositModalOption()
  const modal = useModal('deposit')

  useEffect(() => {
    if (modalOption === DepositModalOption.SelectOption) {
      setTitleName('Deposit')
    } else if (modalOption === DepositModalOption.SelectAssets) {
      setTitleName('Transfer crypto from personal web3')
    } else if (modalOption === DepositModalOption.Qrcode) {
      setTitleName('Transfer crypto from mobile web3')
    }
  }, [modalOption])

  return (
    <ModalLink
      width={'435px'}
      isIn={modal}
      header={titleName}
      onClose={() => {
        dispatch(updateModal({ modal: 'deposit', open: false }))
        dispatch(updateDepositModalOption(DepositModalOption.SelectOption))
      }}
      maskClose={false}
      onHeaderClick={
        modalOption === DepositModalOption.SelectOption
          ? undefined
          : () => {
              dispatch(
                updateDepositModalOption(DepositModalOption.SelectOption),
              )
            }
      }
    >
      {modalOption === DepositModalOption.SelectOption ? (
        <DepositSelectOption />
      ) : modalOption === DepositModalOption.SelectAssets ? (
        <DepositContent />
      ) : modalOption === DepositModalOption.Qrcode ? (
        <DepositQrcode />
      ) : null}
    </ModalLink>
  )
})
